import React, { useCallback, useMemo } from 'react'
import { useFormik } from 'formik'
import { useDispatch, useSelector } from 'react-redux'

import EditForm from '../../../../../../features/components/Forms/EditForm'
import Field from '../../../../../../components/Form/Field'

import { usePurifiedFormik } from '../../../../../../hooks/formHooks/usePurifiedFormik'
import { useEditSectionFormSubmit } from '../../../../../../hooks/formHooks/useEditSectionFormSubmit'

import { updateAd } from '../../../../../../modules/actions/ads'
import { selectedGoogleAdAccountSelector } from '../../../../../../modules/selectors/adAccounts'

import { getInitialValues, validationSchema } from './fields'
import { GOOGLE_PLATFORM } from '../../../../../../constants/selectLists/platformList'
import { LONG_HEADLINE } from '../../../AdGoogleCreate/AdGoogleCreateForm/fields'
import { HISTORY_META_EDIT_SECTION } from '../../../../../../constants/changeHistory'

const LongHeadlineSectionForm = ({ editItemData: ad, successSubmit, isInternalAd, title, ...formProps }) => {
  const dispatch = useDispatch()

  const { id: selectedAdAccountId } = useSelector(selectedGoogleAdAccountSelector)

  const { id, ad_account_id: adAccountId } = ad
  const adAccount = adAccountId || selectedAdAccountId

  const initialValues = useMemo(() => getInitialValues(ad), [ad])

  const handleSubmit = useCallback(
    values => {
      dispatch(
        updateAd(
          {
            account: adAccount,
            responsive_display_ad: {
              long_headline: {
                text: values[LONG_HEADLINE]
              }
            },
            ...(isInternalAd && { internal: true }),
            meta: {
              [HISTORY_META_EDIT_SECTION]: title
            }
          },
          id,
          GOOGLE_PLATFORM
        )
      )
    },
    [dispatch, id, isInternalAd, adAccount, title]
  )

  const { onSubmit, manualSuccessSubmit } = useEditSectionFormSubmit({ initialValues, handleSubmit })

  const formik = useFormik({
    initialValues,
    onSubmit,
    validationSchema,
    enableReinitialize: true
  })

  const purifiedFormik = usePurifiedFormik(formik)

  return (
    <EditForm
      formik={purifiedFormik}
      initialValues={initialValues}
      successSubmit={successSubmit || manualSuccessSubmit}
      {...formProps}
    >
      <Field placeholder="Long Headline" name={LONG_HEADLINE} formik={formik} maxLength={90} />
    </EditForm>
  )
}

export default LongHeadlineSectionForm
